import { render, staticRenderFns } from "./highSchools.vue?vue&type=template&id=1cfce189&scoped=true&"
import script from "./highSchools.vue?vue&type=script&lang=js&"
export * from "./highSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfce189",
  null
  
)

export default component.exports